import { render, staticRenderFns } from "./StartPageQuickLinks.vue?vue&type=template&id=1c920801&"
import script from "./StartPageQuickLinks.vue?vue&type=script&lang=js&"
export * from "./StartPageQuickLinks.vue?vue&type=script&lang=js&"
import style0 from "./StartPageQuickLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports